module.exports = __webpack_public_path__ + "img/1524236035.feb79bf7.jpg";